import React, { useState } from 'react';
import { ChevronRight, Sparkles, Eye, Diamond } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const DiamondJewellery = () => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const navigate = useNavigate();

  const diamondItems = [
    {
      id: 1,
      name: "Signature Diamond Necklaces",
      category: "Diamond Necklace Collection",
      image: "https://3.imimg.com/data3/KM/IA/MY-4092503/signature-diamond-necklace-1000x1000.jpg",
      description: "Elegant signature diamond necklace with brilliant cut diamonds"
    },
    {
      id: 2,
      name: "Solitaire Dream Ring",
      category: "Diamond Ring",
      image: "https://tse1.mm.bing.net/th/id/OIP.ikyAVSKTdyUpG5ZvjxXRYwHaHa?rs=1&pid=ImgDetMain&o=7&rm=3",
      description: "Stunning solitaire diamond ring for your special moments"
    },
    {
      id: 3,
      name: "Festival Diamond Set",
      category: "Diamond Festival Set",
      image: "https://th.bing.com/th/id/OIP.LJrhwJXq1x6zSkVyAfkjBAHaJQ?o=7rm=3&rs=1&pid=ImgDetMain&o=7&rm=3",
      description: "Complete diamond set perfect for festivals and celebrations"
    },
    {
      id: 4,
      name: "Heritage Diamond Ornament",
      category: "Diamond Heritage Ornament",
      image: "https://tse2.mm.bing.net/th/id/OIP.4-Df3tsC5x8yy16MyJ8MkQHaHa?w=2000&h=2000&rs=1&pid=ImgDetMain&o=7&rm=3",
      description: "Traditional heritage diamond ornament with vintage design"
    }
  ];

  const handleInquire = (itemName, itemCategory) => {
    navigate('/contact', { 
      state: { 
        productName: itemName,
        productCategory: itemCategory,
        inquiryType: 'product'
      } 
    });
  };

  return (
    <section className="py-16 bg-gradient-to-b from-gray-100 to-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <Diamond className="text-[#846358]" size={36} />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">Diamond Jewellery</h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Exquisite diamonds for every moment.
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#846358] to-[#c49a6c] mx-auto mt-6 rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {diamondItems.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 group"
              onMouseEnter={() => setHoveredItem(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <div className="relative overflow-hidden h-80 bg-gray-100">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute top-3 left-3 bg-gradient-to-r from-[#846358] to-[#a07a60] text-white text-xs font-semibold px-2 py-1 rounded-full">
                  {item.category}
                </div>
                <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm p-1.5 rounded-full">
                  <Diamond className="text-[#846358]" size={14} />
                </div>
                {hoveredItem === item.id && (
                  <div className="absolute inset-0 bg-black/50 flex items-center justify-center transition-opacity duration-300">
                    <button
                      onClick={() => handleInquire(item.name, item.category)}
                      className="bg-[#846358] hover:bg-[#6d5348] text-white px-6 py-2 rounded-full font-semibold transform transition-all duration-300 hover:scale-105 flex items-center gap-2"
                    >
                      <Eye size={16} />
                      Quick View
                    </button>
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold text-gray-800 mb-2">{item.name}</h3>
                <p className="text-gray-500 text-sm mb-4 line-clamp-2">{item.description}</p>
                <button
                  onClick={() => handleInquire(item.name, item.category)}
                  className="w-full bg-gradient-to-r from-[#846358] to-[#a07a60] hover:from-[#6d5348] hover:to-[#8b6348] text-white px-4 py-2 rounded-lg font-semibold transition-all duration-300 flex items-center justify-center gap-2 group"
                >
                  Inquire Now
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-12">
          <button className="bg-gradient-to-r from-[#846358] to-[#a07a60] hover:from-[#6d5348] hover:to-[#8b6348] text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg">
            View All Diamond Jewellery
          </button>
        </div>
      </div>
    </section>
  );
};

export default DiamondJewellery;